import fileSys from "../fileoprators/fileSystem";
import SettingsOprator from "./settingsoprator";
import { EXPORT_OPTION_SELECTED } from "./consts";
class ExportOptions extends SettingsOprator {
  constructor() {
    super(fileSys.getCfgPath("exportOptions.json"), EXPORT_OPTION_SELECTED);
  }
  getExportSettings() {
    return this.getSettings();
  }
  saveExportSettings(settings) {
    this.saveSettings(settings);
  }
}
export default ExportOptions;



// WEBPACK FOOTER //
// ./src/settings/exportoption.js